export default __webpack_public_path__ + "static/media/movies.inline.acb9492a.svg";